// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");

function Loading(props) {
  var __loading = props.loading;
  var __text = props.text;
  var __img = props.img;
  var img = __img !== undefined ? Caml_option.valFromOption(__img) : undefined;
  var text = __text !== undefined ? __text : "";
  var loading = __loading !== undefined ? __loading : true;
  return JsxRuntime.jsxs("div", {
              children: [
                img !== undefined ? JsxRuntime.jsx("img", {
                        className: "h-32",
                        src: img
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                loading ? JsxRuntime.jsx("img", {
                        className: "h-10 m-4 loading-animation",
                        src: Image$ReactHooksTemplate.sandClock
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                JsxRuntime.jsx("div", {
                      children: text,
                      className: "text-center"
                    })
              ],
              className: "h-full w-full flex flex-col justify-center bg-white"
            });
}

var make = Loading;

exports.make = make;
/* react/jsx-runtime Not a pure module */
